import React, { useEffect, useRef, useState } from "react";
import { Animated, TouchableOpacity, StyleSheet } from "react-native";
import Colors from "../../Resources/Color";
import { useDevice } from "../_layout";

const TRACK_WIDTH = 36;
const TRACK_HEIGHT = 20;
const THUMB_SIZE = 16;
const TRACK_PADDING = 2;
const THUMB_TRANSLATE_END = TRACK_WIDTH - THUMB_SIZE - TRACK_PADDING;

const ToggleSwitch = ({ value, onChange, disabled = false, onHoverChange }) => {
  const [isHovered, setIsHovered] = useState(false);
  const animation = useRef(new Animated.Value(value ? 1 : 0)).current;
  const { isMobile } = useDevice();

  useEffect(() => {
    Animated.timing(animation, {
      toValue: value ? 1 : 0,
      duration: 200,
      useNativeDriver: false,
    }).start();
  }, [animation, value]);

  useEffect(() => {
    onHoverChange?.(isHovered);
  }, [isHovered, onHoverChange]);

  const handlePress = () => {
    if (disabled) return;
    onChange?.(!value);
  };

  return (
    <TouchableOpacity
      style={styles.touchable}
      activeOpacity={0.7}
      onPress={handlePress}
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => !isMobile && setIsHovered(false)}
      hitSlop={{ top: 6, bottom: 6, left: 4, right: 4 }}
    >
      <Animated.View
        style={[
          styles.track,
          {
            backgroundColor: animation.interpolate({
              inputRange: [0, 1],
              outputRange: ["#E0E0E0", Colors.bubbleColor],
            }),
            opacity: disabled ? 0.6 : isHovered ? 0.9 : 1,
          },
        ]}
      >
        <Animated.View
          style={[
            styles.thumb,
            {
              transform: [
                {
                  translateX: animation.interpolate({
                    inputRange: [0, 1],
                    outputRange: [TRACK_PADDING, THUMB_TRANSLATE_END],
                  }),
                },
              ],
            },
          ]}
        />
      </Animated.View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  touchable: {
    paddingVertical: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  track: {
    width: TRACK_WIDTH,
    height: TRACK_HEIGHT,
    borderRadius: TRACK_HEIGHT / 2,
    justifyContent: "center",
  },
  thumb: {
    width: THUMB_SIZE,
    height: THUMB_SIZE,
    borderRadius: THUMB_SIZE / 2,
    backgroundColor: Colors.whiteColor,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
});

export default ToggleSwitch;
